/*
  Minimum order value guard.

  The Liquid templates already disable the checkout CTAs when the cart is below
  the configured minimum. This script keeps that state correct on surfaces that
  are not re-rendered by the Section Rendering API after an AJAX cart update
  (for example the cart notification, or accelerated checkout buttons that sit
  outside the re-rendered container).

  Note: this is a storefront guard only. It improves the buying experience but
  cannot be relied on for hard enforcement, because /checkout can be reached
  directly. Use a Shopify cart & checkout validation function for that.
*/
(function () {
  const config = window.minimumOrder;

  if (!config || !config.enabled || !config.amount || config.amount <= 0) return;

  const BLOCKED_CLASS = 'minimum-order-blocked';
  const FLAG = 'minimumOrderDisabled';

  function setBlocked(isBlocked) {
    document.body.classList.toggle(BLOCKED_CLASS, isBlocked);

    document.querySelectorAll('[name="checkout"]').forEach((element) => {
      if (element.tagName !== 'BUTTON' && element.tagName !== 'INPUT') return;

      if (isBlocked) {
        element.dataset[FLAG] = 'true';
        element.disabled = true;
      } else if (element.dataset[FLAG] === 'true') {
        delete element.dataset[FLAG];
        element.disabled = false;
      }
    });
  }

  function evaluate(totalPrice) {
    if (typeof totalPrice !== 'number') return;
    setBlocked(totalPrice < config.amount);
  }

  function refreshFromCart() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .then((cart) => {
        if (cart) evaluate(cart.total_price);
      })
      .catch(() => {
        /* Leave the server-rendered state untouched if the cart cannot be read. */
      });
  }

  function handleCartUpdate(event) {
    const total = event && event.cartData && event.cartData.total_price;

    if (typeof total === 'number') {
      evaluate(total);
    } else {
      // /cart/add.js responses describe the line item, not the whole cart.
      refreshFromCart();
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
  }

  // Last line of defence for links that point straight at the checkout.
  document.addEventListener('click', (event) => {
    if (!document.body.classList.contains(BLOCKED_CLASS)) return;

    const link = event.target.closest('a[href*="/checkout"]');
    if (!link) return;

    event.preventDefault();
  });

  document.addEventListener('shopify:section:load', refreshFromCart);

  refreshFromCart();
})();
